export default __webpack_public_path__ + "static/media/wave.dbf2c449.png";